import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSnackbar } from 'notistack';

// @mui
import { Box, Grid } from '@mui/material';
// hooks
import useAuth from 'hooks/useAuth';
// components
import Page from 'components/Page';
import LoaderCallApi from 'components/LoaderCallApi';
// sections
import { ResetPasswordForm } from 'sections/auth/resetPassword';
// utils
import { ACTIONS } from 'utils/constants';
import axios from 'utils/axios';
import API from 'restApi';

export default function ResetPassword() {
  const { login } = useAuth();
  const { t } = useTranslation();
  const [version, setVersion] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const { enqueueSnackbar } = useSnackbar();

  // Fetch version on mount
  useEffect(() => {
    const getVersion = async () => {
      try {
        const { data } = await axios.post(API.path, {
          action: ACTIONS.IVRSVERSION
        });
        setVersion(data.version);
      } catch (error) {
        enqueueSnackbar(t("errors.fetchVersionFailed"), { variant: 'error' });
      }
    };

    getVersion();
    // eslint-disable-next-line
  }, []); // Empty dependency array ensures this runs once

  const onSubmitAccount = async (data) => {
    setIsLoading(true); // Set loading state on form submit
    try {
      const { data: { statut, reason } } = await axios.post(API.path, {
        action: ACTIONS.SAVEACCOUNT,
        user: data
      });

      if (statut === "NOK") {
        enqueueSnackbar(reason, { variant: 'error' });
      } else {
        enqueueSnackbar(t("account.resetPasswordSucces"), { variant: 'success' });
        await login(data.logincode, data.newpassword1);
      }
    } catch (error) {
      enqueueSnackbar(error.message || t("errors.genericError"), { variant: 'error' });
    } finally {
      setIsLoading(false); // Reset loading state after API call
    }
  };

  return (
    <Page title={t('login.title')}>
      <Box className="wrapper_intro">
        <Box className="wrapper_intro_ins">
          <Grid container spacing={3}>
            <Grid item xs={12} sm={12} md={7} />
            <Grid item xs={12} sm={12} md={4}>
              <Box className="wrapper_intro_form">
                <Box className="wrapper_logo" />
                {isLoading && <LoaderCallApi />}
                <ResetPasswordForm handleSubmitAccount={onSubmitAccount} />
              </Box>
              <Box className="wrapper_intro_footer">
                <Box className="wrapper_intro_footer_logo" />
                <Box className="wrapper_intro_footer_info">{t('login.footer', { version })}</Box>
              </Box>
            </Grid>
          </Grid>
        </Box>
      </Box>
    </Page>
  );
}
